import clsx from "clsx";
import * as React from "react";

import style from "./Confirm.module.scss";

export interface ConfirmStateProps {}

export interface ConfirmDispatchProps {
  calling?: boolean;
  content: string | React.ReactElement;
  confirmText?: string;
  cancelText?: string;
  variant?: "normal" | "danger";
  callback: () => void;
  closeModal: () => void;
}

export interface ConfirmProps extends ConfirmDispatchProps, ConfirmStateProps {}

export const Confirm: React.FC<ConfirmProps> = ({
  calling = false,
  content,
  cancelText = "キャンセル",
  confirmText = "OK",
  variant = "normal",
  closeModal,
  callback,
}) => {
  return (
    <main className={style.main}>
      <div className={style.header}>
        <div className="mb-3">{content}</div>
      </div>
      <div className={style.body}>
        <div className={style.btnArea}>
          <button className="btn btn-secondary" onClick={() => closeModal()}>
            {cancelText}
          </button>
          <button
            className={clsx(
              "btn",
              variant === "normal" ? style.okBtn : "btn-danger",
            )}
            disabled={calling}
            onClick={() => {
              callback();
              closeModal();
            }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </main>
  );
};

export default Confirm;
